module.exports = __webpack_public_path__ + "static/magic-f711fac72cd91473e69c3608b192cd74.gif";